module.exports = __webpack_public_path__ + "static/img/team-server.75631fd3.png";